import { usePostHog } from '#Root/usePostHog';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useEffect } from 'react';

export function usePostHogUser() {
  const { data } = useCurrentUser();
  const posthog = usePostHog();

  useEffect(() => {
    if (data?.user) {
      posthog.identify(data.user.wordpressUserId.toString());
    }
  }, [data?.user, posthog]);
}
